module.exports = __webpack_public_path__ + "static/media/product_09.014eb8da.jpg";